// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.test.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  defaultTheme: 'nfl',
  production: false,
  amplifyEnv: 'dev',
  serviceEnv: 'val',
  domain: 'https://intldatahub-test.dna.nfl.net',
  contactUsLink: 'https://nfltest.service-now.com/sp?id=esc_sc_cat_item&sys_id=7a9a1c09c312c714e3f638cc050131a6',
  region: 'us-east-1',
  auth: {
    hostname: 'idh-val-login.auth.us-east-1.amazoncognito.com',
    redirect_uri: ['https://intldatahub-test.dna.nfl.net/login'],
    response_type: 'code',
    client_id: '79gtl14cgknjqh9542lgkhjvvj',
    scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    user_pool_id: 'us-east-1_SW6f6krHY',
    identity_pool_id: 'us-east-1:54498b7f-c4cc-497d-8adb-e80f3255c04d',
    domain: 'intldatahub-test.dna.nfl.net',
  },
  api: {
    aws_appsync_graphqlEndpoint: 'https://intldatahub-test.dna.nfl.net/graphql',
    aws_appsync_region: 'us-east-1',
    aws_appsync_authenticationType: 'userPool',
  },
};
